import { historie } from '../history.js';
import { beads } from '../beads.js';
import { settings } from '../settings.js';

export const transform = {};

transform.transform60 = method => {

    // find middle bead of selected beads (to rotate around)

    let lowestRow = null;
    let highestRow = null;
    let lowestColumn = null;
    let highestColumn = null;

    let checkRowsAndColumns = bead => {
        if (!lowestRow) {
            lowestRow = bead.row;
            lowestColumn = bead.column;
            highestRow = bead.row;
            highestColumn = bead.column;
        } else {
            if (bead.row < lowestRow) lowestRow = bead.row;
            if (bead.row > highestRow) highestRow = bead.row;
            if (bead.column < lowestColumn) lowestColumn = bead.column;
            if (bead.column > highestColumn) highestColumn = bead.column;
        }
    };

    // return (x, y) address for (i, j) address

    let findSlantAddress = (i, j) => {
        let myBead = beads.findBead(i, j);
        return myBead.slant;
    };

    // find bead at relative slant address

    let findBeadAtSlant = address => {
        return beads.arr.find(element => element.relativeSlantAddress[0] == address[0] && (element.relativeSlantAddress[1] == address[1]));
    };


    beads.arr.forEach(bead => {
        // assign every bead a slantRow and slantColumn

        let i = bead.column;
        let j = bead.row;
        // if (j % 2 == 0) {
        if (beads.rowOffset[j] == 0) {
            bead.slant = [(j / 2) - i, (j / 2) + i];
        } else {
            bead.slant = [((j + 1) / 2) - i, ((j - 1) / 2) + i];
        }
        bead.wasSelected = false;
        bead.wasAssigned = false;
        if (bead.selected) {
            checkRowsAndColumns(bead);
        }
    });

    let middle = [
        Math.ceil((highestColumn + lowestColumn) / 2),
        Math.ceil((highestRow + lowestRow) / 2),
    ];

    let middleSlantAddress = findSlantAddress(middle[0], middle[1])

    // give all beads a relative slant address

    let x;
    let y;
    let b;
    beads.arr.forEach(bead => {
        if (bead.ignore) {
            bead.relativeSlantAddress = [null, null]; // avoids undefined error in find section
            return;
        };

        x = bead.slant[0];
        y = bead.slant[1];
        bead.relativeSlantAddress = [x-middleSlantAddress[0], y-middleSlantAddress[1]];
    });

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.selected) {
            x = bead.relativeSlantAddress[0];
            y = bead.relativeSlantAddress[1];

            if (method == 'right') {
                b = findBeadAtSlant([x+y,-x]);
            } else if (method == 'left') {
                b = findBeadAtSlant([-y,x+y]);
            }

            bead.wasSelected = true;
            if (b !== undefined) {
                b.wasAssigned = true;
                beads.assign(b.temp, bead);
            }
        }
    });

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.wasAssigned) {
            beads.assign(bead, bead.temp, true);
            beads.select(bead);
        }
        if (!bead.wasAssigned && bead.wasSelected) {
            beads.erase(bead);
        }
    });
    historie.addAction();
};

transform.doTransform = method => {

    if (settings.pattern.rotateCamera) {
        if (method == 'horizontal') {
            method = 'vertical';
        } else if (method == 'vertical') {
            method = 'horizontal';
        }
    }

    let lowestRow = null;
    let highestRow = null;
    let lowestColumn = null;
    let highestColumn = null;
    let checkRowsAndColumns = bead => {
        if (lowestRow == null) {
            lowestRow = bead.row;
            lowestColumn = bead.column;
            highestRow = bead.row;
            highestColumn = bead.column;
        } else {
            if (bead.row < lowestRow) lowestRow = bead.row;
            if (bead.row > highestRow) highestRow = bead.row;
            if (bead.column < lowestColumn) lowestColumn = bead.column;
            if (bead.column > highestColumn) highestColumn = bead.column;
        }
    }

    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        bead.wasSelected = false;
        bead.wasAssigned = false;

        if (bead.selected) {
            checkRowsAndColumns(bead);
        }
    });

    let totalColumns = highestColumn - lowestColumn + 1;
    let totalRows = highestRow - lowestRow + 1;
    let longestSide = Math.max(totalColumns, totalRows);
    let iCount = totalColumns;
    let jCount = totalRows;

    if (method == 'left' || (method == 'right')) {
        if (highestColumn - longestSide <= 0) highestColumn -= (highestColumn - longestSide);
        if (highestRow - longestSide <= 0) highestRow -= (highestRow - longestSide);
        if (lowestColumn + longestSide >= settings.columns) {
            lowestColumn -= (lowestColumn + longestSide) - settings.columns;
        }
        if (lowestRow + longestSide >= settings.rows) {
            lowestRow -= (lowestRow + longestSide) - settings.rows;
        }
        iCount = longestSide;
        jCount = longestSide;
    }

    let myArr = [];

    for (let i = 0; i < iCount; i++) {
        for (let j = 0; j < jCount; j++) {
            let b = beads.findBead(i + lowestColumn, j + lowestRow);
            myArr.push(b);
        }
    }

    let b;
    let counter = 0;

    for (let i = 0; i < iCount; i++) {
        for (let j = 0; j < jCount; j++) {

            let offset = 0;

            if (settings.pattern.transform60) {

                if (totalRows % 2 == 0 && (method !== '180') && (beads.rowOffset[j] == 0)) {
                    if (method == 'vertical') {
                        if (lowestRow % 2 == 0) {
                            offset = 1;
                        } else {
                            offset = -1;
                        }
                    } else {
                        if (lowestRow % 2 == 0) {
                            offset = -1;
                        } else {
                            offset = 1;
                        }
                    }
                } else if (totalRows % 2 == 1 && (method !== 'vertical') && (beads.rowOffset[j] == 0)) {
                    if (lowestRow % 2 == 0) {
                        offset = -1;
                    } else {
                        offset = 1;
                    }
                }
            }

            if (method == 'right') {
                b = beads.findBead(highestColumn - j, i + lowestRow);
            } else if (method == 'left') {
                b = beads.findBead(j + lowestColumn, highestRow - i);
            } else if (method == '180') {
                b = beads.findBead(highestColumn - i + offset, highestRow - j);
            } else if (method == 'horizontal') {
                b = beads.findBead(highestColumn - i + offset, j + lowestRow);
            } else if (method == 'vertical') {
                b = beads.findBead(i + lowestColumn + offset, highestRow - j);
            }


            if (myArr[counter] !== undefined) {
                if (myArr[counter].selected) {
                    myArr[counter].wasSelected = true;
                    if (b !== undefined) {
                        b.wasAssigned = true;
                        beads.assign(b.temp, myArr[counter]);
                    }
                }
            }
            counter++;
        }
    }


    beads.arr.forEach(bead => {
        if (bead.ignore) return;
        if (bead.wasAssigned) {
            beads.assign(bead, bead.temp, true);
            beads.select(bead);
        }
        if (!bead.wasAssigned && bead.wasSelected) {
            beads.erase(bead);
        }
    });
    historie.addAction();
};
